import { createRoute } from "@tanstack/react-router";
import { appLayoutRoute } from "@/routes/layout-routes";
import { AdminLayout } from "@/app/Admin/Screens/AdminLayout";
import { AdminTripsScreen } from "@/app/Admin/Screens/AdminTripsScreen";
import { TripRecordScreen } from "@/app/Cities/Trips/Screens/TripRecordScreen";
import { TripDetailScreen } from "@/app/Cities/Trips/Screens/TripDetailScreen";
import { TripFaqsScreen } from "@/app/Cities/Trips/Screens/TripFaqsScreen";
import { TripArticlesScreen } from "@/app/Cities/Trips/Screens/TripArticlesScreen";
import { fetchQuery } from "@/lib/GraphQLCodegen/fetcher";
import { tripRecordQuery } from "@/app/Cities/Trips/GraphQL/tripRecordQuery";
import CityDrawer from "@/app/Cities/Cities/Drawer/CityDrawer";
import { AdminCitiesScreen } from "@/app/Admin/Screens/AdminCitiesScreen";
import { SettingsCurrencyScreen } from "@/app/Settings/Settings/Screens/SettingsCurrencyScreen";
import { SettingsRelocationPagesScreen } from "@/app/Settings/Admin/RelocationPages/Screens/SettingsRelocationPagesScreen";
import { ToolsScreen } from "@/app/Tools/Screens/ToolsScreen";
import { AgreementTemplatesScreen } from "@/app/ProDrivers/Agreements/Screens/AgreementTemplatesScreen";

export const adminRoute = createRoute({
  path: "/admin",
  getParentRoute: () => appLayoutRoute,
  component: AdminLayout,
});

export const adminCitiesRoute = createRoute({
  path: "/cities",
  component: AdminCitiesScreen,
  getParentRoute: () => adminRoute,
  head: () => ({ meta: [{ title: "Cities - Imoova Admin" }] }),
});

export const adminCityDrawerRoute = createRoute({
  path: "$cityId",
  component: CityDrawer,
  getParentRoute: () => adminCitiesRoute,
  head: () => ({ meta: [{ title: "City - Imoova Admin" }] }),
});

export const adminTripsRoute = createRoute({
  path: "/trips",
  component: AdminTripsScreen,
  getParentRoute: () => adminRoute,
  head: () => ({ meta: [{ title: "Trips - Imoova Admin" }] }),
});

export const adminTripRecordRoute = createRoute({
  path: "/admin/trips/$tripId",
  getParentRoute: () => appLayoutRoute,
  component: TripRecordScreen,
  loader: ({ params }) =>
    fetchQuery(tripRecordQuery, { id: params.tripId }, params.orgId),
  head: () => ({ meta: [{ title: "Trip - Imoova Admin" }] }),
});

export const adminTripDetailRoute = createRoute({
  path: "/",
  getParentRoute: () => adminTripRecordRoute,
  component: TripDetailScreen,
});

export const adminTripFaqsRoute = createRoute({
  path: "/faqs",
  getParentRoute: () => adminTripRecordRoute,
  component: TripFaqsScreen,
});

export const adminTripArticlesRoute = createRoute({
  path: "/articles",
  getParentRoute: () => adminTripRecordRoute,
  component: TripArticlesScreen,
});

export const adminDefaultRatesRoute = createRoute({
  path: "/default-rates",
  component: SettingsCurrencyScreen,
  getParentRoute: () => adminRoute,
  head: () => ({ meta: [{ title: "Default Rates - Imoova Admin" }] }),
});

export const adminRelocationPagesRoute = createRoute({
  path: "/relocation-pages",
  component: SettingsRelocationPagesScreen,
  getParentRoute: () => adminRoute,
  head: () => ({ meta: [{ title: "Relocation Pages - Imoova Admin" }] }),
});

export const adminToolsRoute = createRoute({
  path: "/tools",
  component: ToolsScreen,
  getParentRoute: () => adminRoute,
  head: () => ({ meta: [{ title: "Tools - Imoova Admin" }] }),
});

export const adminAgreementsRoute = createRoute({
  path: "/agreements",
  component: AgreementTemplatesScreen,
  getParentRoute: () => adminRoute,
  head: () => ({ meta: [{ title: "Agreement Templates - Imoova Admin" }] }),
});
